// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3352":"7042880c44e84ac2","4459":"0c3b57948dd1657f","9961":"0d60d3aa9d1580d2"}[chunkId] + ".css";
};